'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('AccessReviewController', ['$scope', '$state', function ($scope, $state) {

    if ($state.is('accessReview')) {
        $state.transitionTo('accessReview.authUser', null,
                            { reload: true, inherit: false });

        return;
    }
}]);
